// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-statistics-summary__container {
    background-color: var(--white-color);
    padding: var(--space-and-half);
    border-radius: var(--space-half);
    height: 300px;
    position: relative;
}

.tournament-statistics-summary__title {
    display: flex;
    justify-content: space-between;
}

.tournament-statistics-summary__row {
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-right: 24px;
}

.tournament-statistics-summary__row_data {
    margin-left: auto;
}

.tournament-statistics-summary__row .yellow-card {
    background-color: var(--new-yellow-warning-color);
    width: var(--space);
    height: var(--space-and-half);
    margin-right: calc(var(--space-half) + 4px);
    margin-left: 2px;
}

.tournament-statistics-summary__row .red-card {
    background-color: var(--error-color);
    width: var(--space);
    height: var(--space-and-half);
    margin-right: calc(var(--space-half) + 4px);
    margin-left: 2px;
}

.tournament-statistics-summary__row .blue-card {
    background-color: #0273FF;
    width: var(--space);
    height: var(--space-and-half);
    margin-right: calc(var(--space-half) + 4px);
    margin-left: 2px;
}

.tournament-statistics-summary__row .icon {
    font-size: 24px;
    margin-right: var(--space-half);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament-statistics-summary__container{
        margin: 12px;
        height: 270px;
    }
}

@media screen and ( min-width: 1440px ) { /* Ajuste para resolucion mas ancha */

    .tournament-statistics-summary__container{
        height: 320px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-statistics-summary/TournamentStatisticsSummaryComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA,0CAA0C,qCAAqC;;IAE3E;QACI,aAAa;IACjB;AACJ","sourcesContent":[".tournament-statistics-summary__container {\n    background-color: var(--white-color);\n    padding: var(--space-and-half);\n    border-radius: var(--space-half);\n    height: 300px;\n    position: relative;\n}\n\n.tournament-statistics-summary__title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-statistics-summary__row {\n    display: flex;\n    align-items: center;\n    margin-top: 16px;\n    margin-right: 24px;\n}\n\n.tournament-statistics-summary__row_data {\n    margin-left: auto;\n}\n\n.tournament-statistics-summary__row .yellow-card {\n    background-color: var(--new-yellow-warning-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-right: calc(var(--space-half) + 4px);\n    margin-left: 2px;\n}\n\n.tournament-statistics-summary__row .red-card {\n    background-color: var(--error-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-right: calc(var(--space-half) + 4px);\n    margin-left: 2px;\n}\n\n.tournament-statistics-summary__row .blue-card {\n    background-color: #0273FF;\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-right: calc(var(--space-half) + 4px);\n    margin-left: 2px;\n}\n\n.tournament-statistics-summary__row .icon {\n    font-size: 24px;\n    margin-right: var(--space-half);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament-statistics-summary__container{\n        margin: 12px;\n        height: 270px;\n    }\n}\n\n@media screen and ( min-width: 1440px ) { /* Ajuste para resolucion mas ancha */\n\n    .tournament-statistics-summary__container{\n        height: 320px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
